/* @generated from adl module ids.db */

import * as ADL from './../runtime/adl';
import * as common from './../common';
import * as common_db from './../common/db';
import * as common_strings from './../common/strings';
import * as ids_common from './common';
import * as ids_hotel from './hotel';

/**
 * Details for a user
 */
export interface AppUser {
  fullname: common_strings.StringNE;
  email: common_strings.StringNE;
  isAdmin: boolean;
  hashedPassword: common_strings.StringNE;
}

export function makeAppUser(
  input: {
    fullname: common_strings.StringNE,
    email: common_strings.StringNE,
    isAdmin: boolean,
    hashedPassword?: common_strings.StringNE,
  }
): AppUser {
  return {
    fullname: input.fullname,
    email: input.email,
    isAdmin: input.isAdmin,
    hashedPassword: input.hashedPassword === undefined ? "" : input.hashedPassword,
  };
}

const AppUser_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["email"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Details for a user\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"fullname","default":{"kind":"nothing"},"name":"fullname","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"email","default":{"kind":"nothing"},"name":"email","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"isAdmin","default":{"kind":"nothing"},"name":"isAdmin","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[],"serializedName":"hashedPassword","default":{"kind":"just","value":""},"name":"hashedPassword","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"AppUser","version":{"kind":"nothing"}}};

export const snAppUser: ADL.ScopedName = {moduleName:"ids.db", name:"AppUser"};

export function texprAppUser(): ADL.ATypeExpr<AppUser> {
  return {value : {typeRef : {kind: "reference", value : snAppUser}, parameters : []}};
}

export type AppUserId = common_db.DbKey<AppUser>;

const AppUserId_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"AppUser"}},"parameters":[]}]}}},"name":"AppUserId","version":{"kind":"nothing"}}};

export const snAppUserId: ADL.ScopedName = {moduleName:"ids.db", name:"AppUserId"};

export function texprAppUserId(): ADL.ATypeExpr<AppUserId> {
  return {value : {typeRef : {kind: "reference", value : snAppUserId}, parameters : []}};
}

/**
 * Represents a category of hotel property
 */
export interface HotelCategory {
  /**
   * Name of category
   */
  name: common_strings.StringNE;
  /**
   * When the category was created
   */
  created: common.Instant;
  /**
   * When the category was last updated
   */
  updated: common.Instant;
}

export function makeHotelCategory(
  input: {
    name: common_strings.StringNE,
    created: common.Instant,
    updated: common.Instant,
  }
): HotelCategory {
  return {
    name: input.name,
    created: input.created,
    updated: input.updated,
  };
}

const HotelCategory_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a category of hotel property\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of category\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the category was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the category was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"HotelCategory","version":{"kind":"nothing"}}};

export const snHotelCategory: ADL.ScopedName = {moduleName:"ids.db", name:"HotelCategory"};

export function texprHotelCategory(): ADL.ATypeExpr<HotelCategory> {
  return {value : {typeRef : {kind: "reference", value : snHotelCategory}, parameters : []}};
}

/**
 * Represents a system hotel property
 */
export interface Hotel {
  /**
   * Name of property
   */
  name: common_strings.StringNE;
  /**
   * The property's address
   */
  address: ids_common.Address;
  /**
   * Id of country hotel is in
   */
  countryId: (common_db.DbKey<Country>|null);
  /**
   * The property's phone number, if present
   */
  phoneNum: (ids_common.PhoneNumber|null);
  /**
   * The property's fax number
   */
  faxNum: (ids_common.PhoneNumber|null);
  /**
   * The property's email address, if present
   */
  emailAddress: (common_strings.EmailAddress|null);
  /**
   * The property's website
   */
  website: (common_strings.StringNE|null);
  /**
   * A curated description of the hotel property, if present
   */
  description: (common_strings.StringNE|null);
  /**
   * Hotel point/coordinates
   */
  point: common.LatLng;
  /**
   * Information about property policies that guests may need to be aware of
   */
  policies: (common_strings.StringNE|null);
  /**
   * The property's category e.g. "Hotel", "Bed & breakfast" etc.
   */
  categoryId: (common_db.DbKey<HotelCategory>|null);
  /**
   * The ID of the chain that the hotel belongs to
   */
  hotelChainId: (common_db.DbKey<HotelChain>|null);
  /**
   * Check in details of the property, if present
   */
  checkInDetails: (ids_hotel.CheckInDetails|null);
  /**
   * A string describing check out time, if present
   */
  checkOutTime: (common.LocalTime|null);
  /**
   * Star rating of hotel with a possible score between 0 to 5
   */
  starRating: ids_common.StarRating;
  /**
   * System computed score for hotel property which will be computed based on booking
   * popularity of hotel in system in the last 3 months
   */
  score: number;
  /**
   * Override score for hotel property, if this exists, it will override the
   * system computed score
   */
  overrideScore: (number|null);
  /**
   * Google place id of hotel
   */
  googlePlaceId: (common_strings.StringNE|null);
  /**
   * Whether the hotel is active
   */
  active: boolean;
  /**
   * When the hotel was created
   */
  created: common.Instant;
  /**
   * When the hotel was last updated
   */
  updated: common.Instant;
}

export function makeHotel(
  input: {
    name: common_strings.StringNE,
    address: ids_common.Address,
    countryId: (common_db.DbKey<Country>|null),
    phoneNum: (ids_common.PhoneNumber|null),
    faxNum: (ids_common.PhoneNumber|null),
    emailAddress: (common_strings.EmailAddress|null),
    website: (common_strings.StringNE|null),
    description: (common_strings.StringNE|null),
    point: common.LatLng,
    policies: (common_strings.StringNE|null),
    categoryId: (common_db.DbKey<HotelCategory>|null),
    hotelChainId: (common_db.DbKey<HotelChain>|null),
    checkInDetails: (ids_hotel.CheckInDetails|null),
    checkOutTime: (common.LocalTime|null),
    starRating?: ids_common.StarRating,
    score?: number,
    overrideScore: (number|null),
    googlePlaceId: (common_strings.StringNE|null),
    active?: boolean,
    created: common.Instant,
    updated: common.Instant,
  }
): Hotel {
  return {
    name: input.name,
    address: input.address,
    countryId: input.countryId,
    phoneNum: input.phoneNum,
    faxNum: input.faxNum,
    emailAddress: input.emailAddress,
    website: input.website,
    description: input.description,
    point: input.point,
    policies: input.policies,
    categoryId: input.categoryId,
    hotelChainId: input.hotelChainId,
    checkInDetails: input.checkInDetails,
    checkOutTime: input.checkOutTime,
    starRating: input.starRating === undefined ? 0 : input.starRating,
    score: input.score === undefined ? 0 : input.score,
    overrideScore: input.overrideScore,
    googlePlaceId: input.googlePlaceId,
    active: input.active === undefined ? false : input.active,
    created: input.created,
    updated: input.updated,
  };
}

const Hotel_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["create index hotel_point_idx on hotel using gist(point);","create index hotel_name_idx on hotel using gin (name gin_trgm_ops);","create index hotel_scores_idx on hotel (override_score desc, score desc);"],"withIdPrimaryKey":true,"indexes":[["categoryId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a system hotel property\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of property\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's address\n"}],"serializedName":"address","default":{"kind":"nothing"},"name":"address","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"Address"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of country hotel is in\n"}],"serializedName":"countryId","default":{"kind":"nothing"},"name":"countryId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Country"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's phone number, if present\n"}],"serializedName":"phoneNum","default":{"kind":"nothing"},"name":"phoneNum","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's fax number\n"}],"serializedName":"faxNum","default":{"kind":"nothing"},"name":"faxNum","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"PhoneNumber"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's email address, if present\n"}],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's website\n"}],"serializedName":"website","default":{"kind":"nothing"},"name":"website","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A curated description of the hotel property, if present\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotel point/coordinates\n"}],"serializedName":"point","default":{"kind":"nothing"},"name":"point","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LatLng"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Information about property policies that guests may need to be aware of\n"}],"serializedName":"policies","default":{"kind":"nothing"},"name":"policies","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's category e.g. \"Hotel\", \"Bed & breakfast\" etc.\n"}],"serializedName":"categoryId","default":{"kind":"nothing"},"name":"categoryId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelCategory"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The ID of the chain that the hotel belongs to\n"}],"serializedName":"hotelChainId","default":{"kind":"nothing"},"name":"hotelChainId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelChain"}},"parameters":[]}]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Check in details of the property, if present\n"}],"serializedName":"checkInDetails","default":{"kind":"nothing"},"name":"checkInDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.hotel","name":"CheckInDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A string describing check out time, if present\n"}],"serializedName":"checkOutTime","default":{"kind":"nothing"},"name":"checkOutTime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Star rating of hotel with a possible score between 0 to 5\n"}],"serializedName":"starRating","default":{"kind":"just","value":0},"name":"starRating","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"StarRating"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"System computed score for hotel property which will be computed based on booking\npopularity of hotel in system in the last 3 months\n"}],"serializedName":"score","default":{"kind":"just","value":0},"name":"score","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Override score for hotel property, if this exists, it will override the\nsystem computed score\n"}],"serializedName":"overrideScore","default":{"kind":"nothing"},"name":"overrideScore","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Google place id of hotel\n"}],"serializedName":"googlePlaceId","default":{"kind":"nothing"},"name":"googlePlaceId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether the hotel is active\n"}],"serializedName":"active","default":{"kind":"just","value":false},"name":"active","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the hotel was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the hotel was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Hotel","version":{"kind":"nothing"}}};

export const snHotel: ADL.ScopedName = {moduleName:"ids.db", name:"Hotel"};

export function texprHotel(): ADL.ATypeExpr<Hotel> {
  return {value : {typeRef : {kind: "reference", value : snHotel}, parameters : []}};
}

/**
 * Represents a parent company which owns a hotel property
 */
export interface HotelChain {
  /**
   * Name of hotel property chain
   */
  name: common_strings.StringNE;
}

export function makeHotelChain(
  input: {
    name: common_strings.StringNE,
  }
): HotelChain {
  return {
    name: input.name,
  };
}

const HotelChain_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a parent company which owns a hotel property\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of hotel property chain\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"HotelChain","version":{"kind":"nothing"}}};

export const snHotelChain: ADL.ScopedName = {moduleName:"ids.db", name:"HotelChain"};

export function texprHotelChain(): ADL.ATypeExpr<HotelChain> {
  return {value : {typeRef : {kind: "reference", value : snHotelChain}, parameters : []}};
}

/**
 * Amenities represent a feature or service available at a hotel property to guests
 */
export interface Amenity {
  /**
   * Name of amenity
   */
  name: common_strings.StringNE;
  /**
   * Level of amenity
   */
  level: ids_hotel.AmenityLevel;
}

export function makeAmenity(
  input: {
    name: common_strings.StringNE,
    level: ids_hotel.AmenityLevel,
  }
): Amenity {
  return {
    name: input.name,
    level: input.level,
  };
}

const Amenity_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Amenities represent a feature or service available at a hotel property to guests\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of amenity\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Level of amenity\n"}],"serializedName":"level","default":{"kind":"nothing"},"name":"level","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.hotel","name":"AmenityLevel"}},"parameters":[]}}]}},"name":"Amenity","version":{"kind":"nothing"}}};

export const snAmenity: ADL.ScopedName = {moduleName:"ids.db", name:"Amenity"};

export function texprAmenity(): ADL.ATypeExpr<Amenity> {
  return {value : {typeRef : {kind: "reference", value : snAmenity}, parameters : []}};
}

/**
 * An alias between a supplier's description of an amenity and the actual
 * definition of an Amenity. For example "Pool with Spa" and "Massive Pool"
 * should map to a an Amenity called "Pool"
 */
export interface AmenityAlias {
  amenityId: common_db.DbKey<Amenity>;
  alias: string;
}

export function makeAmenityAlias(
  input: {
    amenityId: common_db.DbKey<Amenity>,
    alias: string,
  }
): AmenityAlias {
  return {
    amenityId: input.amenityId,
    alias: input.alias,
  };
}

const AmenityAlias_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["alias"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"An alias between a supplier's description of an amenity and the actual\ndefinition of an Amenity. For example \"Pool with Spa\" and \"Massive Pool\"\nshould map to a an Amenity called \"Pool\"\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"amenityId","default":{"kind":"nothing"},"name":"amenityId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Amenity"}},"parameters":[]}]}},{"annotations":[],"serializedName":"alias","default":{"kind":"nothing"},"name":"alias","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}}]}},"name":"AmenityAlias","version":{"kind":"nothing"}}};

export const snAmenityAlias: ADL.ScopedName = {moduleName:"ids.db", name:"AmenityAlias"};

export function texprAmenityAlias(): ADL.ATypeExpr<AmenityAlias> {
  return {value : {typeRef : {kind: "reference", value : snAmenityAlias}, parameters : []}};
}

/**
 * Represents an amenity associated with a hotel property
 */
export interface HotelAmenity {
  /**
   * Id of the hotel the amenity is associated with
   */
  hotelId: common_db.DbKey<Hotel>;
  /**
   * Id of the amenity the hotel is associated with
   * Amenity must be of level property
   */
  amenityId: common_db.DbKey<Amenity>;
}

export function makeHotelAmenity(
  input: {
    hotelId: common_db.DbKey<Hotel>,
    amenityId: common_db.DbKey<Amenity>,
  }
): HotelAmenity {
  return {
    hotelId: input.hotelId,
    amenityId: input.amenityId,
  };
}

const HotelAmenity_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["hotelId","amenityId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an amenity associated with a hotel property\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of the hotel the amenity is associated with\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of the amenity the hotel is associated with\nAmenity must be of level property\n"}],"serializedName":"amenityId","default":{"kind":"nothing"},"name":"amenityId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Amenity"}},"parameters":[]}]}}]}},"name":"HotelAmenity","version":{"kind":"nothing"}}};

export const snHotelAmenity: ADL.ScopedName = {moduleName:"ids.db", name:"HotelAmenity"};

export function texprHotelAmenity(): ADL.ATypeExpr<HotelAmenity> {
  return {value : {typeRef : {kind: "reference", value : snHotelAmenity}, parameters : []}};
}

/**
 * Represents a system hotel room associated with a system hotel property
 */
export interface HotelRoom {
  /**
   * Name of hotel room
   */
  name: common_strings.StringNE;
  /**
   * Description of hotel room
   */
  description: string;
  /**
   * The hotel this room is in
   */
  hotelId: common_db.DbKey<Hotel>;
  /**
   * Bed configurations of hotel room
   */
  bedConfigurations: common.StringList;
  /**
   * Free string which describes room categories of hotel room e.g. family, standard, deluxe
   */
  roomCategories: common.StringList;
  /**
   * Free string which describes accommodation types of hotel room e.g. cottage, apartment
   */
  accommodationTypes: common.StringList;
  /**
   * Free string which describes the room's views e.g. "Ocean view", "Lake view"
   */
  views: common.StringList;
  /**
   * Id of occupancy information, if present
   */
  occupancy: (ids_hotel.Occupancy|null);
  /**
   * Area of the room
   */
  area: (ids_hotel.AreaSqM|null);
  /**
   * When the hotel room was created
   */
  created: common.Instant;
  /**
   * When the hotel room was last updated
   */
  updated: common.Instant;
}

export function makeHotelRoom(
  input: {
    name: common_strings.StringNE,
    description: string,
    hotelId: common_db.DbKey<Hotel>,
    bedConfigurations?: common.StringList,
    roomCategories?: common.StringList,
    accommodationTypes?: common.StringList,
    views?: common.StringList,
    occupancy: (ids_hotel.Occupancy|null),
    area: (ids_hotel.AreaSqM|null),
    created: common.Instant,
    updated: common.Instant,
  }
): HotelRoom {
  return {
    name: input.name,
    description: input.description,
    hotelId: input.hotelId,
    bedConfigurations: input.bedConfigurations === undefined ? [] : input.bedConfigurations,
    roomCategories: input.roomCategories === undefined ? [] : input.roomCategories,
    accommodationTypes: input.accommodationTypes === undefined ? [] : input.accommodationTypes,
    views: input.views === undefined ? [] : input.views,
    occupancy: input.occupancy,
    area: input.area,
    created: input.created,
    updated: input.updated,
  };
}

const HotelRoom_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["hotelId"]],"uniquenessConstraints":[["hotelId","name"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a system hotel room associated with a system hotel property\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of hotel room\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Description of hotel room\n"}],"serializedName":"description","default":{"kind":"nothing"},"name":"description","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The hotel this room is in\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Bed configurations of hotel room\n"}],"serializedName":"bedConfigurations","default":{"kind":"just","value":[]},"name":"bedConfigurations","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringList"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Free string which describes room categories of hotel room e.g. family, standard, deluxe\n"}],"serializedName":"roomCategories","default":{"kind":"just","value":[]},"name":"roomCategories","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringList"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Free string which describes accommodation types of hotel room e.g. cottage, apartment\n"}],"serializedName":"accommodationTypes","default":{"kind":"just","value":[]},"name":"accommodationTypes","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringList"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Free string which describes the room's views e.g. \"Ocean view\", \"Lake view\"\n"}],"serializedName":"views","default":{"kind":"just","value":[]},"name":"views","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringList"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of occupancy information, if present\n"}],"serializedName":"occupancy","default":{"kind":"nothing"},"name":"occupancy","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.hotel","name":"Occupancy"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Area of the room\n"}],"serializedName":"area","default":{"kind":"nothing"},"name":"area","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.hotel","name":"AreaSqM"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the hotel room was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the hotel room was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"HotelRoom","version":{"kind":"nothing"}}};

export const snHotelRoom: ADL.ScopedName = {moduleName:"ids.db", name:"HotelRoom"};

export function texprHotelRoom(): ADL.ATypeExpr<HotelRoom> {
  return {value : {typeRef : {kind: "reference", value : snHotelRoom}, parameters : []}};
}

/**
 * Represents an amenity associated with a hotel room
 */
export interface HotelRoomAmenity {
  /**
   * Id of the hotel room the amenity is associated with
   */
  hotelRoomId: common_db.DbKey<HotelRoom>;
  /**
   * Id of the amenity the hotel room is associated with
   * Amenity must be of level room
   */
  amenityId: common_db.DbKey<Amenity>;
}

export function makeHotelRoomAmenity(
  input: {
    hotelRoomId: common_db.DbKey<HotelRoom>,
    amenityId: common_db.DbKey<Amenity>,
  }
): HotelRoomAmenity {
  return {
    hotelRoomId: input.hotelRoomId,
    amenityId: input.amenityId,
  };
}

const HotelRoomAmenity_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an amenity associated with a hotel room\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of the hotel room the amenity is associated with\n"}],"serializedName":"hotelRoomId","default":{"kind":"nothing"},"name":"hotelRoomId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelRoom"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of the amenity the hotel room is associated with\nAmenity must be of level room\n"}],"serializedName":"amenityId","default":{"kind":"nothing"},"name":"amenityId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Amenity"}},"parameters":[]}]}}]}},"name":"HotelRoomAmenity","version":{"kind":"nothing"}}};

export const snHotelRoomAmenity: ADL.ScopedName = {moduleName:"ids.db", name:"HotelRoomAmenity"};

export function texprHotelRoomAmenity(): ADL.ATypeExpr<HotelRoomAmenity> {
  return {value : {typeRef : {kind: "reference", value : snHotelRoomAmenity}, parameters : []}};
}

/**
 * Represents an image that is associated with a hotel room
 */
export interface HotelRoomImage {
  /**
   * The id of the hotel associated with this image
   */
  roomId: common_db.DbKey<HotelRoom>;
  /**
   * The id of the image associated with this hotel
   */
  imageId: common_db.DbKey<Image>;
  /**
   * Whether this image is the hero image
   */
  isHeroImage: boolean;
}

export function makeHotelRoomImage(
  input: {
    roomId: common_db.DbKey<HotelRoom>,
    imageId: common_db.DbKey<Image>,
    isHeroImage: boolean,
  }
): HotelRoomImage {
  return {
    roomId: input.roomId,
    imageId: input.imageId,
    isHeroImage: input.isHeroImage,
  };
}

const HotelRoomImage_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["roomId"]],"uniquenessConstraints":[["roomId","imageId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an image that is associated with a hotel room\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The id of the hotel associated with this image\n"}],"serializedName":"roomId","default":{"kind":"nothing"},"name":"roomId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"HotelRoom"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The id of the image associated with this hotel\n"}],"serializedName":"imageId","default":{"kind":"nothing"},"name":"imageId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Image"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether this image is the hero image\n"}],"serializedName":"isHeroImage","default":{"kind":"nothing"},"name":"isHeroImage","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"HotelRoomImage","version":{"kind":"nothing"}}};

export const snHotelRoomImage: ADL.ScopedName = {moduleName:"ids.db", name:"HotelRoomImage"};

export function texprHotelRoomImage(): ADL.ATypeExpr<HotelRoomImage> {
  return {value : {typeRef : {kind: "reference", value : snHotelRoomImage}, parameters : []}};
}

/**
 * Represents an image stored on our server
 */
export interface Image {
  /**
   * URL of the image
   */
  url: common_strings.StringNE;
  /**
   * Caption of image
   */
  caption: (common_strings.StringNE|null);
}

export function makeImage(
  input: {
    url: common_strings.StringNE,
    caption: (common_strings.StringNE|null),
  }
): Image {
  return {
    url: input.url,
    caption: input.caption,
  };
}

const Image_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an image stored on our server\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"URL of the image\n"}],"serializedName":"url","default":{"kind":"nothing"},"name":"url","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Caption of image\n"}],"serializedName":"caption","default":{"kind":"nothing"},"name":"caption","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"Image","version":{"kind":"nothing"}}};

export const snImage: ADL.ScopedName = {moduleName:"ids.db", name:"Image"};

export function texprImage(): ADL.ATypeExpr<Image> {
  return {value : {typeRef : {kind: "reference", value : snImage}, parameters : []}};
}

/**
 * Represents an image that is associated with a hotel property
 */
export interface HotelImage {
  /**
   * The id of the hotel associated with this image
   */
  hotelId: common_db.DbKey<Hotel>;
  /**
   * The id of the image associated with this hotel
   */
  imageId: common_db.DbKey<Image>;
  /**
   * Whether this image is the hero image
   */
  isHeroImage: boolean;
}

export function makeHotelImage(
  input: {
    hotelId: common_db.DbKey<Hotel>,
    imageId: common_db.DbKey<Image>,
    isHeroImage: boolean,
  }
): HotelImage {
  return {
    hotelId: input.hotelId,
    imageId: input.imageId,
    isHeroImage: input.isHeroImage,
  };
}

const HotelImage_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["hotelId"],["hotel_id","is_hero_image"]],"uniquenessConstraints":[["hotelId","imageId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an image that is associated with a hotel property\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The id of the hotel associated with this image\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The id of the image associated with this hotel\n"}],"serializedName":"imageId","default":{"kind":"nothing"},"name":"imageId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Image"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether this image is the hero image\n"}],"serializedName":"isHeroImage","default":{"kind":"nothing"},"name":"isHeroImage","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}}]}},"name":"HotelImage","version":{"kind":"nothing"}}};

export const snHotelImage: ADL.ScopedName = {moduleName:"ids.db", name:"HotelImage"};

export function texprHotelImage(): ADL.ATypeExpr<HotelImage> {
  return {value : {typeRef : {kind: "reference", value : snHotelImage}, parameters : []}};
}

/**
 * Represents an image stored on a supplier's server
 */
export interface SupplierImage {
  /**
   * Associated supplier image id
   */
  supplierImageId: string;
  /**
   * URL of the image (on the supplier's server)
   */
  url: common_strings.StringNE;
  /**
   * Caption of image
   */
  caption: (common_strings.StringNE|null);
  /**
   * When the image URL expires (UTC, ISO 8601 format)
   */
  expires: (common.Instant|null);
}

export function makeSupplierImage(
  input: {
    supplierImageId: string,
    url: common_strings.StringNE,
    caption: (common_strings.StringNE|null),
    expires: (common.Instant|null),
  }
): SupplierImage {
  return {
    supplierImageId: input.supplierImageId,
    url: input.url,
    caption: input.caption,
    expires: input.expires,
  };
}

const SupplierImage_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["supplierImageId","url"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an image stored on a supplier's server\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Associated supplier image id\n"}],"serializedName":"supplierImageId","default":{"kind":"nothing"},"name":"supplierImageId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"URL of the image (on the supplier's server)\n"}],"serializedName":"url","default":{"kind":"nothing"},"name":"url","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Caption of image\n"}],"serializedName":"caption","default":{"kind":"nothing"},"name":"caption","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the image URL expires (UTC, ISO 8601 format)\n"}],"serializedName":"expires","default":{"kind":"nothing"},"name":"expires","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}]}}]}},"name":"SupplierImage","version":{"kind":"nothing"}}};

export const snSupplierImage: ADL.ScopedName = {moduleName:"ids.db", name:"SupplierImage"};

export function texprSupplierImage(): ADL.ATypeExpr<SupplierImage> {
  return {value : {typeRef : {kind: "reference", value : snSupplierImage}, parameters : []}};
}

/**
 * Represents an image received from a supplier that is associated with a supplier hotel
 */
export interface SupplierHotelImage {
  /**
   * Database id of the supplier image
   */
  supplierImageId: common_db.DbKey<SupplierImage>;
  /**
   * Database id of the supplier hotel
   */
  supplierHotelId: common_db.DbKey<SupplierHotel>;
  /**
   * Whether this image is marked as the hero image on the supplier's server
   */
  isHeroImage: (boolean|null);
}

export function makeSupplierHotelImage(
  input: {
    supplierImageId: common_db.DbKey<SupplierImage>,
    supplierHotelId: common_db.DbKey<SupplierHotel>,
    isHeroImage: (boolean|null),
  }
): SupplierHotelImage {
  return {
    supplierImageId: input.supplierImageId,
    supplierHotelId: input.supplierHotelId,
    isHeroImage: input.isHeroImage,
  };
}

const SupplierHotelImage_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["supplierImageId","supplierHotelId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an image received from a supplier that is associated with a supplier hotel\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Database id of the supplier image\n"}],"serializedName":"supplierImageId","default":{"kind":"nothing"},"name":"supplierImageId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"SupplierImage"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Database id of the supplier hotel\n"}],"serializedName":"supplierHotelId","default":{"kind":"nothing"},"name":"supplierHotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"SupplierHotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether this image is marked as the hero image on the supplier's server\n"}],"serializedName":"isHeroImage","default":{"kind":"nothing"},"name":"isHeroImage","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}]}}]}},"name":"SupplierHotelImage","version":{"kind":"nothing"}}};

export const snSupplierHotelImage: ADL.ScopedName = {moduleName:"ids.db", name:"SupplierHotelImage"};

export function texprSupplierHotelImage(): ADL.ATypeExpr<SupplierHotelImage> {
  return {value : {typeRef : {kind: "reference", value : snSupplierHotelImage}, parameters : []}};
}

/**
 * Represents amenities available at a hotel from a supplier
 */
export interface SupplierAmenity {
  /**
   * Associated supplier amenity id
   */
  supplierAmenityId: string;
  /**
   * Name of amenity
   */
  name: common_strings.StringNE;
  /**
   * Level of amenity
   */
  level: ids_hotel.AmenityLevel;
}

export function makeSupplierAmenity(
  input: {
    supplierAmenityId: string,
    name: common_strings.StringNE,
    level: ids_hotel.AmenityLevel,
  }
): SupplierAmenity {
  return {
    supplierAmenityId: input.supplierAmenityId,
    name: input.name,
    level: input.level,
  };
}

const SupplierAmenity_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["supplierAmenityId","level"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents amenities available at a hotel from a supplier\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Associated supplier amenity id\n"}],"serializedName":"supplierAmenityId","default":{"kind":"nothing"},"name":"supplierAmenityId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of amenity\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Level of amenity\n"}],"serializedName":"level","default":{"kind":"nothing"},"name":"level","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.hotel","name":"AmenityLevel"}},"parameters":[]}}]}},"name":"SupplierAmenity","version":{"kind":"nothing"}}};

export const snSupplierAmenity: ADL.ScopedName = {moduleName:"ids.db", name:"SupplierAmenity"};

export function texprSupplierAmenity(): ADL.ATypeExpr<SupplierAmenity> {
  return {value : {typeRef : {kind: "reference", value : snSupplierAmenity}, parameters : []}};
}

/**
 * Represents an amenity received from a supplier that is associated with a supplier hotel
 */
export interface SupplierHotelAmenity {
  /**
   * Database id of the supplier amenity
   */
  supplierAmenityId: common_db.DbKey<SupplierAmenity>;
  /**
   * Database id of the supplier hotel
   */
  supplierHotelId: common_db.DbKey<SupplierHotel>;
}

export function makeSupplierHotelAmenity(
  input: {
    supplierAmenityId: common_db.DbKey<SupplierAmenity>,
    supplierHotelId: common_db.DbKey<SupplierHotel>,
  }
): SupplierHotelAmenity {
  return {
    supplierAmenityId: input.supplierAmenityId,
    supplierHotelId: input.supplierHotelId,
  };
}

const SupplierHotelAmenity_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["supplierAmenityId","supplierHotelId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an amenity received from a supplier that is associated with a supplier hotel\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Database id of the supplier amenity\n"}],"serializedName":"supplierAmenityId","default":{"kind":"nothing"},"name":"supplierAmenityId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"SupplierAmenity"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Database id of the supplier hotel\n"}],"serializedName":"supplierHotelId","default":{"kind":"nothing"},"name":"supplierHotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"SupplierHotel"}},"parameters":[]}]}}]}},"name":"SupplierHotelAmenity","version":{"kind":"nothing"}}};

export const snSupplierHotelAmenity: ADL.ScopedName = {moduleName:"ids.db", name:"SupplierHotelAmenity"};

export function texprSupplierHotelAmenity(): ADL.ATypeExpr<SupplierHotelAmenity> {
  return {value : {typeRef : {kind: "reference", value : snSupplierHotelAmenity}, parameters : []}};
}

export enum SupplierType {
  hotel,
}

const SupplierType_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier type - for now, we only support a hotel supplier type\n"}],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"hotel","default":{"kind":"nothing"},"name":"hotel","typeExpr":{"typeRef":{"kind":"primitive","value":"Void"},"parameters":[]}}]}},"name":"SupplierType","version":{"kind":"nothing"}}};

export const snSupplierType: ADL.ScopedName = {moduleName:"ids.db", name:"SupplierType"};

export function texprSupplierType(): ADL.ATypeExpr<SupplierType> {
  return {value : {typeRef : {kind: "reference", value : snSupplierType}, parameters : []}};
}

/**
 * Represents a supplier of some type - currently the system only supports a hotel supplier type
 */
export interface Supplier {
  /**
   * Name of supplier
   */
  name: common_strings.StringNE;
  supplierType: SupplierType;
  /**
   * Config parameters for that supplier. It is expected that this JSON blob
   * would correspond to an ADL type that represents a supplier's config parameters
   */
  config: ({}|null|null);
  /**
   * When the supplier was created
   */
  created: common.Instant;
  /**
   * When the supplier was last updated
   */
  updated: common.Instant;
}

export function makeSupplier(
  input: {
    name: common_strings.StringNE,
    supplierType: SupplierType,
    config?: ({}|null|null),
    created: common.Instant,
    updated: common.Instant,
  }
): Supplier {
  return {
    name: input.name,
    supplierType: input.supplierType,
    config: input.config === undefined ? null : input.config,
    created: input.created,
    updated: input.updated,
  };
}

const Supplier_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a supplier of some type - currently the system only supports a hotel supplier type\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of supplier\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"supplierType","default":{"kind":"nothing"},"name":"supplierType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"SupplierType"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Config parameters for that supplier. It is expected that this JSON blob\nwould correspond to an ADL type that represents a supplier's config parameters\n"}],"serializedName":"config","default":{"kind":"just","value":null},"name":"config","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Json"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the supplier was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the supplier was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Supplier","version":{"kind":"nothing"}}};

export const snSupplier: ADL.ScopedName = {moduleName:"ids.db", name:"Supplier"};

export function texprSupplier(): ADL.ATypeExpr<Supplier> {
  return {value : {typeRef : {kind: "reference", value : snSupplier}, parameters : []}};
}

/**
 * Represents key information about a hotel that is retrieved from a supplier
 */
export interface SupplierHotel {
  /**
   * Associated supplier id
   */
  supplierId: common_db.DbKey<Supplier>;
  /**
   * Supplier hotel id (unique identifier the supplier associates for this hotel)
   */
  supplierHotelId: string;
  /**
   * Name of hotel
   */
  name: common_strings.StringNE;
  /**
   * The property's phone number, if present
   */
  phoneNum: common.StringList;
  /**
   * The property's fax number, if present
   */
  faxNum: (common_strings.StringNE|null);
  /**
   * The property's email address, if present
   */
  emailAddress: (common_strings.EmailAddress|null);
  /**
   * Address of hotel
   */
  address: ids_common.Address;
  /**
   * Hotel point/coordinates
   * This field is null if the supplier doesn't provide this data.
   */
  point: (common.LatLng|null);
  /**
   * The property's category e.g. Hotel
   */
  category: (common_strings.StringNE|null);
  /**
   * Information about property policies that guests may need to be aware of
   */
  policies: (common_strings.StringNE|null);
  /**
   * Star rating of hotel with a possible score between 0 to 5, if present
   */
  starRating: (ids_common.StarRating|null);
  /**
   * Check in details of the property, if present
   */
  checkInDetails: (ids_hotel.CheckInDetails|null);
  /**
   * A string describing check out time, if present
   */
  checkOutTime: (common.LocalTime|null);
  /**
   * TODO(jess): Confirm if we need to store this.
   * Hotel rating
   */
  rating: (number|null);
  /**
   * When the supplier hotel was created
   */
  created: common.Instant;
  /**
   * When the supplier hotel was last updated
   */
  updated: common.Instant;
}

export function makeSupplierHotel(
  input: {
    supplierId: common_db.DbKey<Supplier>,
    supplierHotelId: string,
    name: common_strings.StringNE,
    phoneNum: common.StringList,
    faxNum: (common_strings.StringNE|null),
    emailAddress: (common_strings.EmailAddress|null),
    address: ids_common.Address,
    point: (common.LatLng|null),
    category: (common_strings.StringNE|null),
    policies: (common_strings.StringNE|null),
    starRating: (ids_common.StarRating|null),
    checkInDetails: (ids_hotel.CheckInDetails|null),
    checkOutTime: (common.LocalTime|null),
    rating: (number|null),
    created: common.Instant,
    updated: common.Instant,
  }
): SupplierHotel {
  return {
    supplierId: input.supplierId,
    supplierHotelId: input.supplierHotelId,
    name: input.name,
    phoneNum: input.phoneNum,
    faxNum: input.faxNum,
    emailAddress: input.emailAddress,
    address: input.address,
    point: input.point,
    category: input.category,
    policies: input.policies,
    starRating: input.starRating,
    checkInDetails: input.checkInDetails,
    checkOutTime: input.checkOutTime,
    rating: input.rating,
    created: input.created,
    updated: input.updated,
  };
}

const SupplierHotel_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["supplierId"]],"uniquenessConstraints":[["supplierId","supplierHotelId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents key information about a hotel that is retrieved from a supplier\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Associated supplier id\n"}],"serializedName":"supplierId","default":{"kind":"nothing"},"name":"supplierId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Supplier"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier hotel id (unique identifier the supplier associates for this hotel)\n"}],"serializedName":"supplierHotelId","default":{"kind":"nothing"},"name":"supplierHotelId","typeExpr":{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of hotel\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's phone number, if present\n"}],"serializedName":"phoneNum","default":{"kind":"nothing"},"name":"phoneNum","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"StringList"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's fax number, if present\n"}],"serializedName":"faxNum","default":{"kind":"nothing"},"name":"faxNum","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's email address, if present\n"}],"serializedName":"emailAddress","default":{"kind":"nothing"},"name":"emailAddress","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"EmailAddress"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Address of hotel\n"}],"serializedName":"address","default":{"kind":"nothing"},"name":"address","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"Address"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Hotel point/coordinates\nThis field is null if the supplier doesn't provide this data.\n"}],"serializedName":"point","default":{"kind":"nothing"},"name":"point","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LatLng"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"The property's category e.g. Hotel\n"}],"serializedName":"category","default":{"kind":"nothing"},"name":"category","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Information about property policies that guests may need to be aware of\n"}],"serializedName":"policies","default":{"kind":"nothing"},"name":"policies","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Star rating of hotel with a possible score between 0 to 5, if present\n"}],"serializedName":"starRating","default":{"kind":"nothing"},"name":"starRating","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"StarRating"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Check in details of the property, if present\n"}],"serializedName":"checkInDetails","default":{"kind":"nothing"},"name":"checkInDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.hotel","name":"CheckInDetails"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A string describing check out time, if present\n"}],"serializedName":"checkOutTime","default":{"kind":"nothing"},"name":"checkOutTime","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalTime"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"TODO(jess): Confirm if we need to store this.\nHotel rating\n"}],"serializedName":"rating","default":{"kind":"nothing"},"name":"rating","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the supplier hotel was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the supplier hotel was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"SupplierHotel","version":{"kind":"nothing"}}};

export const snSupplierHotel: ADL.ScopedName = {moduleName:"ids.db", name:"SupplierHotel"};

export function texprSupplierHotel(): ADL.ATypeExpr<SupplierHotel> {
  return {value : {typeRef : {kind: "reference", value : snSupplierHotel}, parameters : []}};
}

/**
 * Represents a hotel that has been mapped to a supplier hotel as equivalent
 */
export interface HotelSupplierHotel {
  /**
   * System hotel id the supplier hotel has been mapped to
   */
  hotelId: common_db.DbKey<Hotel>;
  /**
   * Supplier hotel id the system hotel has been mapped to
   */
  supplierHotelId: common_db.DbKey<SupplierHotel>;
  /**
   * Whether this mapping has been verified.
   */
  isVerified: boolean;
  /**
   * When the hotel supplier hotel was created
   */
  created: common.Instant;
  /**
   * When the hotel supplier hotel was last updated
   */
  updated: common.Instant;
}

export function makeHotelSupplierHotel(
  input: {
    hotelId: common_db.DbKey<Hotel>,
    supplierHotelId: common_db.DbKey<SupplierHotel>,
    isVerified?: boolean,
    created: common.Instant,
    updated: common.Instant,
  }
): HotelSupplierHotel {
  return {
    hotelId: input.hotelId,
    supplierHotelId: input.supplierHotelId,
    isVerified: input.isVerified === undefined ? false : input.isVerified,
    created: input.created,
    updated: input.updated,
  };
}

const HotelSupplierHotel_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["hotelId","supplierHotelId"]],"uniquenessConstraints":[["hotelId","supplierHotelId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a hotel that has been mapped to a supplier hotel as equivalent\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"System hotel id the supplier hotel has been mapped to\n"}],"serializedName":"hotelId","default":{"kind":"nothing"},"name":"hotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Hotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Supplier hotel id the system hotel has been mapped to\n"}],"serializedName":"supplierHotelId","default":{"kind":"nothing"},"name":"supplierHotelId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"SupplierHotel"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether this mapping has been verified.\n"}],"serializedName":"isVerified","default":{"kind":"just","value":false},"name":"isVerified","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the hotel supplier hotel was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the hotel supplier hotel was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"HotelSupplierHotel","version":{"kind":"nothing"}}};

export const snHotelSupplierHotel: ADL.ScopedName = {moduleName:"ids.db", name:"HotelSupplierHotel"};

export function texprHotelSupplierHotel(): ADL.ATypeExpr<HotelSupplierHotel> {
  return {value : {typeRef : {kind: "reference", value : snHotelSupplierHotel}, parameters : []}};
}

/**
 * Represents a polygon-bounded geographic region
 */
export interface Region {
  /**
   * Name of region
   */
  name: common_strings.StringNE;
  /**
   * Geographic polygon definition of region
   */
  polygon: common.GeoPolygon;
  /**
   * Region rating
   */
  rating: number;
  /**
   * Context for the region's location, e.g. NSW, Australia
   */
  context: (string|null);
  /**
   * When the region was created
   */
  created: common.Instant;
  /**
   * When the region was last updated
   */
  updated: common.Instant;
}

export function makeRegion(
  input: {
    name: common_strings.StringNE,
    polygon: common.GeoPolygon,
    rating: number,
    context?: (string|null),
    created: common.Instant,
    updated: common.Instant,
  }
): Region {
  return {
    name: input.name,
    polygon: input.polygon,
    rating: input.rating,
    context: input.context === undefined ? null : input.context,
    created: input.created,
    updated: input.updated,
  };
}

const Region_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["create index region_polygon_idx on region using gist(polygon);","create index region_name_idx on region using gin (name gin_trgm_ops);","create index region_context_idx on region using gin (context gin_trgm_ops);","create index region_rating_idx on region (rating desc);","create index region_rating_name_idx on region (rating desc, name asc);"],"withIdPrimaryKey":true}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a polygon-bounded geographic region\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of region\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Geographic polygon definition of region\n"}],"serializedName":"polygon","default":{"kind":"nothing"},"name":"polygon","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"GeoPolygon"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Region rating\n"}],"serializedName":"rating","default":{"kind":"nothing"},"name":"rating","typeExpr":{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Context for the region's location, e.g. NSW, Australia\n"}],"serializedName":"context","default":{"kind":"just","value":null},"name":"context","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"String"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the region was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the region was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Region","version":{"kind":"nothing"}}};

export const snRegion: ADL.ScopedName = {moduleName:"ids.db", name:"Region"};

export function texprRegion(): ADL.ATypeExpr<Region> {
  return {value : {typeRef : {kind: "reference", value : snRegion}, parameters : []}};
}

/**
 * Represents a region's sub-region relationship to another region
 * e.g. The Pyrmont region is part of the Sydney CBD region.
 */
export interface SubRegion {
  /**
   * Id of parent region
   */
  parentId: common_db.DbKey<Region>;
  /**
   * Id of child region
   */
  childId: common_db.DbKey<Region>;
  /**
   * When the sub-region was created
   */
  created: common.Instant;
  /**
   * When the sub-region was last updated
   */
  updated: common.Instant;
}

export function makeSubRegion(
  input: {
    parentId: common_db.DbKey<Region>,
    childId: common_db.DbKey<Region>,
    created: common.Instant,
    updated: common.Instant,
  }
): SubRegion {
  return {
    parentId: input.parentId,
    childId: input.childId,
    created: input.created,
    updated: input.updated,
  };
}

const SubRegion_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["parentId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a region's sub-region relationship to another region\ne.g. The Pyrmont region is part of the Sydney CBD region.\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of parent region\n"}],"serializedName":"parentId","default":{"kind":"nothing"},"name":"parentId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Region"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of child region\n"}],"serializedName":"childId","default":{"kind":"nothing"},"name":"childId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Region"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the sub-region was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the sub-region was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"SubRegion","version":{"kind":"nothing"}}};

export const snSubRegion: ADL.ScopedName = {moduleName:"ids.db", name:"SubRegion"};

export function texprSubRegion(): ADL.ATypeExpr<SubRegion> {
  return {value : {typeRef : {kind: "reference", value : snSubRegion}, parameters : []}};
}

/**
 * Represents a country
 */
export interface Country {
  /**
   * ISO 316-1 alpha-2 code
   */
  code: ids_common.CountryCode;
  /**
   * Name of country
   */
  name: common_strings.StringNE;
  /**
   * Polygon-defined viewport to render country
   */
  viewPort: (common.GeoPolygon|null);
  /**
   * Polygon-defined bounds of country
   */
  bounds: (common.GeoPolygon|null);
  /**
   * Center of country
   */
  center: (common.LatLng|null);
  /**
   * When the country was created
   */
  created: common.Instant;
  /**
   * When the country was last updated
   */
  updated: common.Instant;
}

export function makeCountry(
  input: {
    code: ids_common.CountryCode,
    name: common_strings.StringNE,
    viewPort: (common.GeoPolygon|null),
    bounds: (common.GeoPolygon|null),
    center: (common.LatLng|null),
    created: common.Instant,
    updated: common.Instant,
  }
): Country {
  return {
    code: input.code,
    name: input.name,
    viewPort: input.viewPort,
    bounds: input.bounds,
    center: input.center,
    created: input.created,
    updated: input.updated,
  };
}

const Country_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"],["code"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a country\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"ISO 316-1 alpha-2 code\n"}],"serializedName":"code","default":{"kind":"nothing"},"name":"code","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ids.common","name":"CountryCode"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of country\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Polygon-defined viewport to render country\n"}],"serializedName":"viewPort","default":{"kind":"nothing"},"name":"viewPort","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"GeoPolygon"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Polygon-defined bounds of country\n"}],"serializedName":"bounds","default":{"kind":"nothing"},"name":"bounds","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"GeoPolygon"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Center of country\n"}],"serializedName":"center","default":{"kind":"nothing"},"name":"center","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LatLng"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the country was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the country was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Country","version":{"kind":"nothing"}}};

export const snCountry: ADL.ScopedName = {moduleName:"ids.db", name:"Country"};

export function texprCountry(): ADL.ATypeExpr<Country> {
  return {value : {typeRef : {kind: "reference", value : snCountry}, parameters : []}};
}

/**
 * Represents a point of interest category
 */
export interface PoiCategory {
  /**
   * Name of category
   */
  name: common_strings.StringNE;
  /**
   * When the category was created
   */
  created: common.Instant;
  /**
   * When the category was last updated
   */
  updated: common.Instant;
}

export function makePoiCategory(
  input: {
    name: common_strings.StringNE,
    created: common.Instant,
    updated: common.Instant,
  }
): PoiCategory {
  return {
    name: input.name,
    created: input.created,
    updated: input.updated,
  };
}

const PoiCategory_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"uniquenessConstraints":[["name"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a point of interest category\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of category\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the category was created\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the category was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"PoiCategory","version":{"kind":"nothing"}}};

export const snPoiCategory: ADL.ScopedName = {moduleName:"ids.db", name:"PoiCategory"};

export function texprPoiCategory(): ADL.ATypeExpr<PoiCategory> {
  return {value : {typeRef : {kind: "reference", value : snPoiCategory}, parameters : []}};
}

/**
 * Represents a point of interest
 */
export interface Poi {
  /**
   * Name of point of interest
   */
  name: common_strings.StringNE;
  /**
   * A short display-ready string describing the
   * location context of the point of interest, if present
   */
  context: (common_strings.StringNE|null);
  /**
   * Whether the point of interest is active
   */
  isActive: boolean;
  /**
   * Id of category point of interest is associated with
   */
  categoryId: common_db.DbKey<PoiCategory>;
  /**
   * Point of interest's point/coordinates
   */
  point: common.LatLng;
  /**
   * Decimal rating (1-5) of point of interest
   */
  rating: (number|null);
  /**
   * When the point of interest was created;
   */
  created: common.Instant;
  /**
   * When the point of interest was last updated
   */
  updated: common.Instant;
}

export function makePoi(
  input: {
    name: common_strings.StringNE,
    context: (common_strings.StringNE|null),
    isActive: boolean,
    categoryId: common_db.DbKey<PoiCategory>,
    point: common.LatLng,
    rating: (number|null),
    created: common.Instant,
    updated: common.Instant,
  }
): Poi {
  return {
    name: input.name,
    context: input.context,
    isActive: input.isActive,
    categoryId: input.categoryId,
    point: input.point,
    rating: input.rating,
    created: input.created,
    updated: input.updated,
  };
}

const Poi_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["create index poi_point_idx on poi using gist(point);","create index poi_name_idx on poi using gin (name gin_trgm_ops);","create index poi_context_idx on poi using gin (context gin_trgm_ops);","create index poi_rating_idx on poi (rating desc);"],"withIdPrimaryKey":true,"indexes":[["categoryId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a point of interest\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Name of point of interest\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"A short display-ready string describing the\nlocation context of the point of interest, if present\n"}],"serializedName":"context","default":{"kind":"nothing"},"name":"context","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Whether the point of interest is active\n"}],"serializedName":"isActive","default":{"kind":"nothing"},"name":"isActive","typeExpr":{"typeRef":{"kind":"primitive","value":"Bool"},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of category point of interest is associated with\n"}],"serializedName":"categoryId","default":{"kind":"nothing"},"name":"categoryId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"PoiCategory"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Point of interest's point/coordinates\n"}],"serializedName":"point","default":{"kind":"nothing"},"name":"point","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LatLng"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Decimal rating (1-5) of point of interest\n"}],"serializedName":"rating","default":{"kind":"nothing"},"name":"rating","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Double"},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the point of interest was created;\n"}],"serializedName":"created","default":{"kind":"nothing"},"name":"created","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"When the point of interest was last updated\n"}],"serializedName":"updated","default":{"kind":"nothing"},"name":"updated","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"Poi","version":{"kind":"nothing"}}};

export const snPoi: ADL.ScopedName = {moduleName:"ids.db", name:"Poi"};

export function texprPoi(): ADL.ATypeExpr<Poi> {
  return {value : {typeRef : {kind: "reference", value : snPoi}, parameters : []}};
}

/**
 * Represents an alternate name/alias for
 * a point of interest. A point of interest
 * may have more than one alternate name
 */
export interface PoiAlias {
  /**
   * Id of point of interest
   */
  poiId: common_db.DbKey<Poi>;
  /**
   * Alternate name for point of interest
   */
  name: common_strings.StringNE;
}

export function makePoiAlias(
  input: {
    poiId: common_db.DbKey<Poi>,
    name: common_strings.StringNE,
  }
): PoiAlias {
  return {
    poiId: input.poiId,
    name: input.name,
  };
}

const PoiAlias_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"extraSql":["create index poi_alias_name_idx on poi_alias using gin(name gin_trgm_ops);"],"withIdPrimaryKey":true,"uniquenessConstraints":[["poiId","name"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents an alternate name/alias for\na point of interest. A point of interest\nmay have more than one alternate name\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of point of interest\n"}],"serializedName":"poiId","default":{"kind":"nothing"},"name":"poiId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Poi"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Alternate name for point of interest\n"}],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}}]}},"name":"PoiAlias","version":{"kind":"nothing"}}};

export const snPoiAlias: ADL.ScopedName = {moduleName:"ids.db", name:"PoiAlias"};

export function texprPoiAlias(): ADL.ATypeExpr<PoiAlias> {
  return {value : {typeRef : {kind: "reference", value : snPoiAlias}, parameters : []}};
}

/**
 * Represents a point of interest in a region
 */
export interface RegionPoi {
  /**
   * Id of region POI is in
   */
  regionId: common_db.DbKey<Region>;
  /**
   * Id of POI in region
   */
  poiId: common_db.DbKey<Poi>;
}

export function makeRegionPoi(
  input: {
    regionId: common_db.DbKey<Region>,
    poiId: common_db.DbKey<Poi>,
  }
): RegionPoi {
  return {
    regionId: input.regionId,
    poiId: input.poiId,
  };
}

const RegionPoi_AST : ADL.ScopedDecl =
  {"moduleName":"ids.db","decl":{"annotations":[{"v1":{"moduleName":"common.db","name":"DbTable"},"v2":{"withIdPrimaryKey":true,"indexes":[["poiId"]]}},{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Represents a point of interest in a region\n"}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of region POI is in\n"}],"serializedName":"regionId","default":{"kind":"nothing"},"name":"regionId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Region"}},"parameters":[]}]}},{"annotations":[{"v1":{"moduleName":"sys.annotations","name":"Doc"},"v2":"Id of POI in region\n"}],"serializedName":"poiId","default":{"kind":"nothing"},"name":"poiId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.db","name":"DbKey"}},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ids.db","name":"Poi"}},"parameters":[]}]}}]}},"name":"RegionPoi","version":{"kind":"nothing"}}};

export const snRegionPoi: ADL.ScopedName = {moduleName:"ids.db", name:"RegionPoi"};

export function texprRegionPoi(): ADL.ATypeExpr<RegionPoi> {
  return {value : {typeRef : {kind: "reference", value : snRegionPoi}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ids.db.AppUser" : AppUser_AST,
  "ids.db.AppUserId" : AppUserId_AST,
  "ids.db.HotelCategory" : HotelCategory_AST,
  "ids.db.Hotel" : Hotel_AST,
  "ids.db.HotelChain" : HotelChain_AST,
  "ids.db.Amenity" : Amenity_AST,
  "ids.db.AmenityAlias" : AmenityAlias_AST,
  "ids.db.HotelAmenity" : HotelAmenity_AST,
  "ids.db.HotelRoom" : HotelRoom_AST,
  "ids.db.HotelRoomAmenity" : HotelRoomAmenity_AST,
  "ids.db.HotelRoomImage" : HotelRoomImage_AST,
  "ids.db.Image" : Image_AST,
  "ids.db.HotelImage" : HotelImage_AST,
  "ids.db.SupplierImage" : SupplierImage_AST,
  "ids.db.SupplierHotelImage" : SupplierHotelImage_AST,
  "ids.db.SupplierAmenity" : SupplierAmenity_AST,
  "ids.db.SupplierHotelAmenity" : SupplierHotelAmenity_AST,
  "ids.db.SupplierType" : SupplierType_AST,
  "ids.db.Supplier" : Supplier_AST,
  "ids.db.SupplierHotel" : SupplierHotel_AST,
  "ids.db.HotelSupplierHotel" : HotelSupplierHotel_AST,
  "ids.db.Region" : Region_AST,
  "ids.db.SubRegion" : SubRegion_AST,
  "ids.db.Country" : Country_AST,
  "ids.db.PoiCategory" : PoiCategory_AST,
  "ids.db.Poi" : Poi_AST,
  "ids.db.PoiAlias" : PoiAlias_AST,
  "ids.db.RegionPoi" : RegionPoi_AST
};
